import React, { useEffect, useRef, useState } from "react";
import "./magneticgrid.css";

const MOBILE_BREAKPOINT = 768;

const GRID_SIZE = 20;
const BASE_RADIUS = 1;
const MAX_RADIUS = 3;
const EFFECT_RADIUS = 60;
const EASE = 0.16;

type Dot = {
  x: number;
  y: number;
};

const MagneticGrid: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const [enabled, setEnabled] = useState(
    () => window.innerWidth > MOBILE_BREAKPOINT
  );

  useEffect(() => {
    const handleResize = () => {
      setEnabled(window.innerWidth > MOBILE_BREAKPOINT);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!enabled) return;

    const canvas = canvasRef.current;
    if (!canvas) return;

const hero = canvas.closest(".hero-section") as HTMLElement;

if (!hero) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    let animationId = 0;

    const mouse = {
      x: -1000,
      y: -1000,
      tx: -1000,
      ty: -1000,
    };

    let dots: Dot[] = [];
const resize = () => {
  const dpr = window.devicePixelRatio || 1;
  
  // 1. Get the actual absolute width of the browser window
  const width = window.innerWidth;
  const height = hero.clientHeight; // Keep the height aligned to the hero container

  // 2. Set the canvas inner backing store size
  canvas.width = width * dpr;
  canvas.height = height * dpr;

  // 3. Match the CSS dimensions exactly
  canvas.style.width = `${width}px`;
  canvas.style.height = `${height}px`;

  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

  dots = [];

  // 4. Generate the dots across the true screen width
  for (let y = 0; y <= height; y += GRID_SIZE) {
    for (let x = 0; x <= width; x += GRID_SIZE) {
      dots.push({ x, y });
    }
  }
};
resize();
   
const handleMove = (e: MouseEvent) => {
  const rect = canvas.getBoundingClientRect();
  // Compute mouse position relative to the canvas bounding box
  mouse.tx = e.clientX - rect.left;
  mouse.ty = e.clientY - rect.top;
};

    const handleLeave = () => {
      mouse.tx = -1000;
      mouse.ty = -1000;
    };

hero.addEventListener("mousemove", handleMove);
hero.addEventListener("mouseleave", handleLeave);
    window.addEventListener("resize", resize);

    const draw = () => {
      const rect = hero.getBoundingClientRect();

      mouse.x += (mouse.tx - mouse.x) * EASE;
      mouse.y += (mouse.ty - mouse.y) * EASE;

      ctx.clearRect(0, 0, rect.width, rect.height);

      for (const dot of dots) {
        const dx = mouse.x - dot.x;
        const dy = mouse.y - dot.y;

        const distance = Math.sqrt(dx * dx + dy * dy);

        const influence = Math.exp(
          -(distance * distance) / (2 * EFFECT_RADIUS * EFFECT_RADIUS)
        );

        const offsetX = dx * influence * 0.012;
        const offsetY = dy * influence * 0.012;

        const radius = BASE_RADIUS + (MAX_RADIUS - BASE_RADIUS) * influence;

        const alpha = 0.08 + influence * 0.72;

        const r = Math.round(150 + (94 - 150) * influence);
        const g = Math.round(165 + (139 - 165) * influence);
        const b = Math.round(205 + (255 - 205) * influence);

        ctx.beginPath();
        ctx.arc(dot.x + offsetX, dot.y + offsetY, radius, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${r},${g},${b},${alpha})`;
        ctx.fill();
      }

      animationId = requestAnimationFrame(draw);
    };

    draw();

    return () => {
      cancelAnimationFrame(animationId);
      hero.removeEventListener("mousemove", handleMove);
      hero.removeEventListener("mouseleave", handleLeave);
      window.removeEventListener("resize", resize);
    };
  }, [enabled]);

  if (!enabled) return null;

  return <canvas ref={canvasRef} className="magnetic-grid" />;
};

export default MagneticGrid;